export default class Warranty {
  setPrincipalIdNumberWithoutVD(value) {
    this.principalIdNumberWithoutVD = value || '';
    return this;
  }

  setIdNumberWithoutVD(value) {
    this.idNumberWithoutVD = value || '';
    return this;
  }

  setAssignmentDate(value) {
    this.assignmentDate = value || '';
    return this;
  }

  setGuarantorIdNumberWithoutVD(value) {
    this.guarantorIdNumberWithoutVD = value || '';
    return this;
  }

  setSecuritizerIdNumberWithoutVD(value) {
    this.securitizerIdNumberWithoutVD = value || '';
    return this;
  }

  setAndesCompanyOperationId(value) {
    this.andesCompanyOperationId = value || '';
    return this;
  }

  setCodebtorType(value) {
    this.codebtorType = value || '';
    return this;
  }
}
